// Copyright (c) 2025 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const AdditionalDetailsDataTestDomain = t.list(KeyValuePair, 'KeyValuePair');

export const getDefaultState = () => new AdditionalDetailsDataTestDomain([]);

export default AdditionalDetailsDataTestDomain;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/additional-data-test-domain.js